import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage'
import { combineReducers } from "redux";
import { persistReducer } from 'redux-persist'
import UserReducer from "./reducers/UserReducer";
import TokenReducer from "./reducers/TokenReducer";
import NotificationCountReducer from "./reducers/NotificationCountReducer";
import MenuOpenCloseReducer from "./reducers/MenuOpenCloseReducer";
import logger from 'redux-logger'
import thunk from 'redux-thunk'

const reducers = combineReducers({
    user: UserReducer,
    token: TokenReducer,
    notificationCount: NotificationCountReducer,
    menuOpenClose: MenuOpenCloseReducer,
});

const persistConfig = {
    key: 'root',
    storage
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: [thunk]
});

export default store;